// extracted by mini-css-extract-plugin
export default {"vmvValeurs":"VMVValeurs_vmvValeurs__mWf9g","vmvValeurs__valeurs":"VMVValeurs_vmvValeurs__valeurs__ty9vC","vmvValeurs__valeurs__item":"VMVValeurs_vmvValeurs__valeurs__item__jZ8dg"};